/** Canonical JSON for hashing: sorted keys, sorted assignment rows. */
export function canonicalSchedule(s) {
    const sortBy = (xs, key) => [...xs].sort((a, b) => (key(a) < key(b) ? -1 : key(a) > key(b) ? 1 : 0));
    const c = {
        participants: sortBy(s.participants, (p) => p.participantId),
        rooms: sortBy(s.rooms, (r) => r.roomId),
        rounds: sortBy(s.rounds, (r) => String(r.sequence).padStart(6, '0') + r.roundId),
        assignments: sortBy(s.assignments, (a) => `${a.roundId}|${a.participantId}`),
    };
    return JSON.stringify(c, (_k, v) => (v && typeof v === 'object' && !Array.isArray(v) ? Object.fromEntries(Object.entries(v).sort()) : v));
}
/** FNV-1a 64-bit, hex. Runtime-neutral (no node:crypto) so it runs in the client too. */
export function fnv1a64(text) {
    let h = 0xcbf29ce484222325n;
    const prime = 0x100000001b3n;
    const mask = 0xffffffffffffffffn;
    for (let i = 0; i < text.length; i++) {
        h ^= BigInt(text.charCodeAt(i));
        h = (h * prime) & mask;
    }
    return h.toString(16).padStart(16, '0');
}
export function makeScheduleVersion(schedule, version, now = () => new Date()) {
    return { version, createdAt: now().toISOString(), schedule, hash: fnv1a64(canonicalSchedule(schedule)) };
}
export function roundsInOrder(s) {
    return [...s.rounds].sort((a, b) => a.sequence - b.sequence);
}
export function nextRound(s, current) {
    const rs = roundsInOrder(s);
    if (current === null)
        return rs[0];
    const i = rs.findIndex((r) => r.roundId === current);
    return i < 0 ? undefined : rs[i + 1];
}
/** Destination per participant for a round, straight from the schedule. */
export function plannedDestinations(s, roundId) {
    const m = new Map();
    for (const a of s.assignments)
        if (a.roundId === roundId)
            m.set(a.participantId, a.destinationRoomId);
    return m;
}
//# sourceMappingURL=schedule.js.map